define('model/reviewer.unit.assignment.model',['require','exports','module','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel = require('fukit').BaseModel;

  var DisclosureUnsubmittedReportModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureUnsubmittedReportModel': '@constructor',
    },

    urlRoot: '/api/v2/coi/export/fileLink/reviewerslist',
  });

  module.exports = DisclosureUnsubmittedReportModel;
});

